import { render } from "./ImprintView.vue?vue&type=template&id=75f0a456&scoped=true"
const script = {}

import "./ImprintView.vue?vue&type=style&index=0&id=75f0a456&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75f0a456"]])

export default __exports__